<template>
  <v-col class="col-lg-4 col-md-6 col-sm-12" v-if="!withActions || !isQuilt">
    <v-card>
      <v-img
        :height="height"
        :src="image"
      />
      <v-card-title>
        <h6>{{description}} <span>{{position}}</span></h6>
        <v-tooltip bottom max-width="300" v-if="withActions">
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              v-bind="attrs"
              v-on="on"
            >fa-info-circle</v-icon>
          </template>
          <div>
            <p>{{details}}</p>
            <p v-if="warning">{{warning}}</p>
          </div>
        </v-tooltip>
      </v-card-title>
      <v-card-subtitle class="price-text" v-if="price">{{price | currency}}</v-card-subtitle>
      <v-card-subtitle v-if="threadColor"><strong>Stitching color:</strong> {{ threadColor }}</v-card-subtitle>
      <v-card-actions v-if="withActions">
        <v-switch :value="selected" @change="add" label="Add this option"></v-switch>
      </v-card-actions>
    </v-card>
  </v-col>
</template>

<style scoped lang="scss">
.v-card__text {
  padding-bottom: 0;
}
.v-card__actions {
  padding: 0 16px;
}
.v-input--switch {
  margin: 0;
}
.v-icon {
  position: absolute;
  right: 10px;
}
h6 {
  font-family: $body-font-family !important;
  font-size: 15px;
  font-weight: 700;
  line-height: 22px;

  @media screen and (min-width: 600px) {
    font-size: 18px;
  }

  span {
    display: block;
    font-size: 13px;
    font-weight: 300;
  }
}
.price-text {
  font-size: 18px;
  font-weight: 700;
}
</style>

<script>
  import { mapState, mapGetters } from 'vuex'

  export default {
    data() {
      return {
        selected: this.added
      }
    },
    props: {
      position: String,
      index: Number,
      name: String,
      added: Boolean,
      withActions: Boolean,
      image: String,
      description: String,
      details: String,
      warning: String,
      color: Object,
      RetailPrice: Number,
      tier1Price: Number,
      tier2Price: Number,
      tier3Price: Number,
      tier4Price: Number,
      tier5Price: Number,
      small: Boolean,
      threadColor: String,
    },
    computed: {
      ...mapState([
        'pricing',
      ]),
      ...mapGetters([
        'priceOption',
      ]),
      isQuilt: function() {
        return this.name.includes('Quilt')
      },
      price() {
        if (this.priceOption) {
          return this[this.priceOption(this.pricing)]
        }
        return ''
      },
      colorName: function() {
        return this.color ? this.color.name : ''
      },
      height: function() {
        return this.small ? 140 : 200
      }
    },
    methods: {
      add(added) {
        const { position, index } = this
        this.$store.commit('addOption', {position, index, added})
      }
    }
  }
</script>
